import { Popover } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const dotStyle = (color, corner = false) => ({
    display: 'inline-block',
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: color,
    ...(corner
        ? {
            position: 'absolute',
            top: 4,
            right: 6,
            zIndex: 1,
            marginLeft: 0,
        }
        : {
            marginLeft: 6,
            verticalAlign: 'middle',
        }),
});

// Hover popover showing a field's Input Source and PDF value, if any.
// Renders bare children when sourceInfo is null (nothing to compare/show).
const MismatchPopover = ({ sourceInfo, formatValue, children }) => {
    if (!sourceInfo) return children;
    const { source, pdfValue, mismatch } = sourceInfo;
    const content = (
        <div style={{ maxWidth: 320 }}>
            <div><strong>Input Source:</strong> {source}</div>
            {pdfValue != null && (
                <div style={{ wordBreak: 'break-word' }}><strong>PDF Value:</strong> {formatValue ? formatValue(pdfValue) : pdfValue}</div>
            )}
        </div>
    );
    // Mismatch always wins the dot color (red); otherwise color by source.
    const dotColor = mismatch ? 'red' : source === 'System' ? '#1890ff' : '#52c41a';
    const hasElementChild = React.isValidElement(children);
    const isFormControl =
        hasElementChild &&
        (children.props.name ||
            children.props.onChange ||
            children.props.value !== undefined ||
            children.props.defaultValue !== undefined);
    const child = isFormControl
        ? React.cloneElement(children, {
            style: {
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                ...children.props.style,
            },
        })
        : children;
    const wrapperStyle = isFormControl
        ? {
            position: 'relative',
            display: 'block',
            width: '100%',
            maxWidth: '100%',
        }
        : {
            display: 'inline-flex',
            alignItems: 'center',
            maxWidth: '100%',
            backgroundColor: mismatch ? '#ffed09' : undefined,
            padding: mismatch ? '0 4px' : undefined,
            borderRadius: mismatch ? 3 : undefined,
        };

    return (
        <Popover content={content} trigger="hover">
            <span style={wrapperStyle}>
                {child}
                <span style={dotStyle(dotColor, isFormControl)} />
            </span>
        </Popover>
    );
};
MismatchPopover.propTypes = {
    sourceInfo: PropTypes.shape({
        source: PropTypes.oneOf(['PDF', 'System', 'Manual']).isRequired,
        pdfValue: PropTypes.any,
        mismatch: PropTypes.bool,
    }),
    formatValue: PropTypes.func,
    children: PropTypes.node,
};

export { MismatchPopover };
